/* ORRA update 8: on phones and tablets the product's main action follows the shopper once the first one scrolls away. */
(function () {
  try {
    var p = document.querySelector('[data-a2-primary]');
    if (!p || !('IntersectionObserver' in window)) return;
    var h1 = document.querySelector('h1');
    var pr = document.querySelector('.a2-info .a2-price b, .a2-price b');
    var bar = document.createElement('div');
    bar.className = 'a2-stk';
    var t = document.createElement('div'); t.className = 't';
    var b = document.createElement('b'); b.textContent = h1 ? h1.textContent.trim() : '';
    var s = document.createElement('span'); s.textContent = pr ? pr.textContent.trim() : '';
    t.appendChild(b); if (s.textContent) t.appendChild(s);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'a2-btn'; btn.textContent = p.textContent.trim();
    btn.addEventListener('click', function () { p.click(); });
    bar.appendChild(t); bar.appendChild(btn); document.body.appendChild(bar);
    var io = new IntersectionObserver(function (e) {
      var r = e[0];
      bar.classList.toggle('on', !r.isIntersecting && r.boundingClientRect.top < 0);
    });
    io.observe(p);
  } catch (x) {}
})();
